import React from 'react';
import styles from './WhatsApp.module.css';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsApp = () => {
  const phoneNumber = '919154884214';
  const message = 'Hi! I need more information about your services.';

  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappLink}
      className={styles.whatsappFloat}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp className={styles.whatsappIcon} />
    </a>
  );
};

export default WhatsApp;